import type { NextPage } from 'next'

import { condominiumCredit } from 'data/seo/condominium-credit'
import { CondominiumCredit } from 'views/condominium-credit'

const CondominiumCreditPage: NextPage = () => <CondominiumCredit />

export default CondominiumCreditPage

export async function getStaticProps() {
  return {
    props: { SEO: condominiumCredit }
  }
}
